import { FC, PropsWithChildren, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { useCurrentCompany, useCurrentUser, useIdentity } from '@bonusly/who-am-i';

import { PageLoading } from '../components/loading';

export const AppLoading: FC<PropsWithChildren> = ({ children }) => {
	const { isUserIdentified } = useIdentity();
	const company = useCurrentCompany();
	const user = useCurrentUser();
	const { i18n, t } = useTranslation('monarch');

	useEffect(() => {
		const locale = user?.locale || company?.locale;

		if (locale) {
			i18n.changeLanguage(locale);
		}
	}, [company?.locale, i18n, user]);

	if (!isUserIdentified) {
		return <PageLoading>{t('loading')}</PageLoading>;
	}

	return <>{children}</>;
};
